import { Component, OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ProblemInstance, RoutesResult, ProblemInstanceService, RoutesService } from 'planner-shared';

@Component({
    selector: 'app-routes-comparison-modal',
    templateUrl: './routes-comparison-modal.component.html',
    styleUrls: ['./routes-comparison-modal.component.scss'],
    standalone: false
})
export class RoutesComparisonModalComponent implements OnInit {
    private readonly problemInstanceService = inject(ProblemInstanceService);
    private readonly routesService = inject(RoutesService);

    public set parameter(isRideSharingInRoute: boolean) {
        this.isRideSharingInRoute = isRideSharingInRoute;
    }

    public isRideSharingInRoute: boolean;
    public cancel$: Subject<void>;
    public routeResult: RoutesResult[] = [];
    public jobId: string[] = [];
    public problemInstance: ProblemInstance;
    public isAlternativeSolution: boolean;

    constructor() {
        this.cancel$ = new Subject();
    }

    ngOnInit(): void{
        let problem: ProblemInstance;
        this.problemInstanceService.getProblemInstance()
            .subscribe(instance => problem = instance.problemInstance);

        problem.jobIdInfos.forEach(jobIdInfo => {
            this.routesService
                .getRoutes(jobIdInfo.jobId)
                .subscribe(route => {
                    this.isAlternativeSolution = jobIdInfo.jobConfigurationDeltaList.length !== 0;
                    if(this.isAlternativeSolution) {
                        this.jobId[0] = jobIdInfo.jobId;
                        this.routeResult[0] = route;
                    } else {
                        this.jobId[1] = jobIdInfo.jobId;
                        this.routeResult[1] = route;
                    }
                });
        });
    }

    public dismissModal(): void {
        this.cancel$.next();
    }
}
